import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface PasswordRulesProps {
  password: string;
  className?: string;
}

export const PasswordRules = ({ password, className }: PasswordRulesProps) => {
  const { t } = useTranslation();

  const rules = {
    minLength: password?.length >= 8,
    upperCase: /[A-Z]/.test(password),
    lowerCase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  return (
    <div className={`password-rules ${className}`}>
      <span className={classNames("rule", { "success": rules.minLength })}>
        8+ {t("passwordRules.characters")}
      </span>
      <span className="fs-18 mr-4 point">•</span>
      <span className={classNames("rule", { "success": rules.upperCase })}>
        {t("passwordRules.uppercaseLetter")}
      </span>
      <span className="fs-18 mr-4 point">•</span>
      <span className={classNames("rule", { "success": rules.lowerCase })}>
        {t("passwordRules.lowercaseLetter")}
      </span>
      <span className="fs-18 mr-4 point">•</span>
      <span className={classNames("rule", { "success": rules.specialChar })}>
        {t("passwordRules.symbol")}
      </span>
      <span className="fs-18 mr-4 point">•</span>
      <span className={classNames("rule", { "success": rules.number })}>
        {t("passwordRules.number")}
      </span>
    </div>
  );
};
